export const BASE_URL = "https://busy-lumiere.103-212-121-158.plesk.page/";
export const AUTHENTICATION_URL = "https://busy-lumiere.103-212-121-158.plesk.page";
export const AppConfig = {
  url: BASE_URL,
  grantType: "password",
  refreshTokenGrantType: "refresh_token",
  //clientId: "mec-app",
  //clientSecret: "R0ya1M3CM0b",
  scopes: "",
};